'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { DbAttachment } from '../../Attachments/types';
import type { MarkdownContent } from '..';
export type MarkdownEditorState = {
  markdown: string;
  attachments: DbAttachment[];
};
const getStorageKey = () => {
  if (globalThis.window === undefined) return '';
  return `markdownEditorContent-${globalThis.location.pathname}`;
};
const saveContentToLocalStorage = (content: MarkdownEditorState) => {
  if (!globalThis.window) return;
  try {
    localStorage.setItem(getStorageKey(), JSON.stringify(content));
  } catch (error) {
    console.error('Failed to save editor content to localStorage', error);
  }
};
const loadContentFromLocalStorage = (): MarkdownEditorState | null => {
  if (!globalThis.window) return null;
  try {
    const data = localStorage.getItem(getStorageKey());
    if (!data) return null;
    return JSON.parse(data) as MarkdownEditorState;
  } catch (error) {
    console.error('Failed to load editor content from localStorage', error);
    return null;
  }
};
export function useEditorLocalStorage(value, t0) {
  const $ = _c(12);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== value) {
    t1 = () => value ?? {
      markdown: "",
      attachments: []
    };
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [initialValue, setInitialValue] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== enabled || $[3] !== value) {
    t2 = () => {
      if (!enabled) {
        return;
      }
      const stored = loadContentFromLocalStorage();
      if (!value && stored) {
        setInitialValue(stored);
      }
    };
    t3 = [value, enabled];
    $[2] = enabled;
    $[3] = value;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== enabled || $[7] !== value) {
    t4 = () => {
      if (!enabled || !value) {
        return;
      }
      const timeout = setTimeout(() => {
        saveContentToLocalStorage({
          markdown: value.markdown,
          attachments: value.attachments ?? []
        });
      }, 750);
      return () => clearTimeout(timeout);
    };
    t5 = [value, enabled];
    $[6] = enabled;
    $[7] = value;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== initialValue) {
    t6 = [initialValue, setInitialValue];
    $[10] = initialValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6 as const;
}